import Vue from "vue"
import FormInvalidFeedback from '@/components/forms/FormInvalidFeedback'
Vue.component('form-invalid-feedback', FormInvalidFeedback)
export default {
    install(Vue){
        Vue.prototype.debug = () => {
            process.env != 'production' && console.log.apply(null,arguments)
        }
    }
}